import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import Club from '../../../Icons/Club';
import "./ClubShow.linaria.module.css!=!./ClubShow?./ClubShow.linaria.module.css?css=H4sIAAAAAAAAA23LQW7DIBCF4X1P0WW7ILIru1HpYRDgAZOOBwRjOxTl7lEWXqTq8p9530nzos6owlYnPDcbMWa56fwmhNH2x+e40iQybJALvH/fXk4P4KzqqxkI059sl7VwcFXYSAzEsiRtQRjgHYAOPqt+/oyX9fe5msbgSQSGpUgLxJAPYYsyjnx0z9VcJBY7BD+zHLvumH8V1fN1Dxu2KZSEukqHcD3e/ZjyOA2qzkNn3D+n15I0tUVnH0ggOJYf6aHvja4Iay4BAAA="
const ClubShowRootStyles = "atm_7l_ivydl7 atm_fc_1yb4nlp atm_h_1h6ojuz atm_cs_bfngof atm_9s_1txwivl";
const iconContainerStyles = "atm_h_1h6ojuz atm_9s_1txwivl atm_15pr5d4_yh40bf";
interface ClubShowBannerProps {
  className?: LinariaClassName;
  style?: CSSProperties;
  iconSize?: number;
}
const ClubShowBanner = memo((props: ClubShowBannerProps) => {
  const {
    className,
    iconSize,
    style
  } = props;
  return <div data-testid="Container__ClubShowBanner" className={cx(ClubShowRootStyles, className)} style={style}>
            <span data-testid="Label_ShowStatus">Club Show</span>
            <span className={iconContainerStyles}>
                <Club size={iconSize} />
            </span>
        </div>;
});
export default ClubShowBanner;
export { ClubShowBanner };